import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'onboarding', en);
i18next.addResources('fr', 'onboarding', fr);

declare global {
  interface RegisteredLocales {
    onboarding: typeof en;
  }
}
